import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en";
import it from "./locales/it";
import zh from "./locales/zh";
import es from "./locales/es";
import de from "./locales/de";
import pt from "./locales/pt";
import Store from "./redux/store";

// import all i18n resources
const resources = {
    EN: { translation: en },
    IT: { translation: it },
    ZH: { translation: zh },
    ES: { translation: es },
    DE: { translation: de },
    PT: { translation: pt },
};

/**
 * 初始化浏览器语言加载
 * 1、国家代码表：
 *    意大利语(意大利)it-it   简体中文(中国)zh-cn  英语(全球)en-ww
 *    法语(法国)fr-fr  西班牙语(西班牙)es-es    德语(德国)de-de
 * 2、获取当前所在地区的语言，初始化该语言
 * 3、默认设置为英文
 * 4、对比当前已有的语言  没有默认给定EN
 */

let lang = navigator.language.substring(0, 2).toLocaleUpperCase();
let result = Object.keys(resources).filter(item => item === lang);
lang = result.length > 0 ? lang : 'EN';
Store.dispatch({
    type: 'SET_CACHING',
    path: 'language',
    value: lang
})
i18n
    // passes i18n down to react-i18next
    .use(initReactI18next)
    .init({
        resources,
        lng: "EN",
        keySeparator: false,

        interpolation: {
            // react already safes from xss
            escapeValue: false
        }
    });

export default i18n;